export const CONFIG = {
	READ_DEBOUNCE: 1500,
};
